import * as echarts from "echarts";
import { chartsWidth, handelProfitrate,dataLength, emptyData, handelZoom, handelLineType, handelWatermark, handelSwitchs, fetchBtcPrice, fetchEthPrice, handelSmaData } from "../../util/processingData"

export default {
    data() {
        return {
            lengthTimer:null,
            rewardLoading: false,
            params: {
                req: "reward",
                radius: "ETH",
                start: "",
                END: ""
            },
            option: {
                tooltip: {
                    trigger: "axis",
                    position: function (pt) {
                        return [pt[0], "10%"];
                    },
                },
                legend: {
                    right: "100",
                    // data:[`sopr`,'asopr','easopr','lthsopr','sthsopr',],
                    // selected:{
                    //     'asopr': false,
                    //     'easopr': false,
                    //     'lthsopr': false,
                    //     'sthsopr': false,                      
                    // }
                },
                xAxis: {
                    type: "time",
                    boundaryGap: false,
                    //   axisLabel: {
                    //     formatter: `{yyyy}-{MM}-{dd}`,
                    //   },
                    data: []
                },
                yAxis: [
                    {
                        type: "value",
                        // boundaryGap: [0, "100%"],
                        axisLabel: {
                            formatter: function (e) {

                                let value;
                                if (e > 100000000) {
                                    value = `${e / 100000000}E`;
                                } else if (e > 1000000) {//百万
                                    value = `${e / 1000000}M`;
                                } else if (e > 10000) {//万
                                    value = `${e / 10000}W`;
                                } else {
                                    value = e;
                                }
                                return value;
                            },
                        },
                        min: "dataMin",
                        max: "dataMax",

                    },
                    {
                        type: "value",
                        // boundaryGap: [0, "100%"],
                        show: true,
                        position: "right",
                        min: "dataMin",
                        max: "dataMax",

                    },
                    {
                        type: "value",
                        // boundaryGap: [0, "100%"],
                        show: true,
                        position: "right",
                        min: "dataMin",
                        max: "dataMax",

                    },

                ],
                dataZoom: [
                    {
                        type: "inside",
                        start: 20,
                        end: 100,
                    },
                    {
                        start: 0,
                        end: 100,
                    },
                ],
                series: [
                    {
                        name: "ETH2 Staking rewards",
                        type: "line",
                        smooth: false,
                        symbol: "circle",
                        showSymbol: false,
                        symbolSize: 5,
                        // areaStyle: {},
                        itemStyle: {
                            color: "#f7931a",
                            borderColor: "rgba(221,220,107,0.1)",
                            borderWidth: 12,
                        },
                        lineStyle: {
                            //线条样式
                            color: "#f7931a",
                            width: "1",
                        },
                        data: [],
                    },
                    // {
                    //     name: "Price[BTC]",
                    //     type: "line",
                    //     smooth: false,
                    //     symbol: "circle",
                    //     symbolSize: 5,
                    //     showSymbol: false,
                    //     // areaStyle: {},
                    //     itemStyle: {
                    //         color: "#888888",
                    //         borderColor: "rgba(221,220,107,0.1)",
                    //         borderWidth: 12,
                    //     },
                    //     lineStyle: {
                    //         //线条样式
                    //         color: "#888888",
                    //         width: "1",
                    //     },
                    //     yAxisIndex: 1,
                    //     data: [],
                    //     //绘制右侧Y轴
                    //     markLine: {
                    //         symbol: ["none", "none"], //去掉箭头
                    //         itemStyle: {
                    //             normal: {
                    //                 lineStyle: { type: "solid", color: "rgba(0,0,0,0.01)" },
                    //             },
                    //         },
                    //         // lineStyle:{
                    //         //   color:"red"
                    //         // },

                    //         label: {
                    //             formatter: "{b}",
                    //             fontSize: 10,
                    //             color: "rgba(0,0,0,0.8)",
                    //             align: "left",
                    //         },
                    //         data: [
                    //             // {
                    //             //     name: "0",
                    //             //     yAxis: 0,
                    //             // },
                    //             //  {
                    //             //   name: "$40W",
                    //             //   yAxis: 400000,
                    //             // },
                    //             {
                    //                 name: "$70W",
                    //                 yAxis: 700000,
                    //             },
                    //             {
                    //                 name: "$40W",
                    //                 yAxis: 400000,
                    //             },

                    //             {
                    //                 name: "$10W",
                    //                 yAxis: 100000,
                    //             },
                    //             {
                    //                 name: "$100W",
                    //                 yAxis: 1000000,
                    //                 // position: ['100%', '50'],
                    //             },
                    //             {
                    //                 name: "$120W",
                    //                 yAxis: 1200000,
                    //             },

                    //             {
                    //                 name: "$140W",
                    //                 yAxis: 1400000,
                    //             },
                    //         ],
                    //     },
                    // },
                    {
                        name: "Price [ETH]",
                        type: "line",
                        smooth: false, //线条是否圆滑
                        symbol: "circle",
                        symbolSize: 5,
                        showSymbol: false,
                        itemStyle: {
                            color: "#627eea",
                            borderColor: "rgba(221,220,107,0.1)",
                            borderWidth: 12,
                        },
                        lineStyle: {
                            //线条样式
                            color: "#627eea",
                            width: "1",
                        },
                        yAxisIndex: 2,
                        data: [],
                    },

                ],
            },
            rewardData: [],
            switch3: "",
            btcFlag: null,
            ethFlag: null,
            fatherSmaData: [],
            start: "",
            end: "",
            sma: "",
            zoomStart: 0,
            zoomEnd: 0,
        }
    },
    mounted() {
        this.switch3 = handelSwitchs(this.option, this.switch3)

        this.fetchReward(this.params.req, this.params.radius)

        this.ethFlag = JSON.parse(localStorage.getItem("ethFlag"));
        this.btcFlag = JSON.parse(localStorage.getItem("btcFlag"));
        this.$addStorageEvent(1, "zoomStart", this.zoomStart);
        this.$addStorageEvent(1, "zoomEnd", this.zoomEnd);

        window.addEventListener("setItem", () => {
            this.ethFlag = JSON.parse(localStorage.getItem("ethFlag"));
            this.btcFlag = JSON.parse(localStorage.getItem("btcFlag"));
            this.zoomStart = localStorage.getItem("zoomStart")
            this.zoomEnd = localStorage.getItem("zoomEnd")

        })
    },
    methods: {
        //初始化图表
        inCharts() {
            if (this.myChart == null) {
                this.myChart = echarts.init(document.getElementById("rewardRateBox"));
            }
            this.option = handelZoom(this.myChart, this.option, this, this.zoomStart, this.zoomEnd)

            this.myChart.setOption(this.option);
            chartsWidth("rewardRateBox", this);
            window.addEventListener("resize", () => {
                if (this.myChart) this.myChart.resize();
            });
        },
        async fetchReward(req, radius, start, end, sma) {
            this.rewardLoading = true
            const { data } = await this.$API.getCsupply(req, radius, start, end, sma)
            this.rewardData = data.data

            //空数据处理
            let noData = emptyData(data.data, this.option.series, this.inCharts, this)
            if (noData) {
                this.rewardLoading = false
                return
            }
            this.start = this.rewardData[0].date.split("T")[0]
            this.end = this.rewardData[this.rewardData.length - 1].date.split("T")[0]
            //添加水印
            this.option = handelWatermark(this.option)

            //根据渲染的数据时间渲染对应的价格线和移动平均线
            // this.$nextTick(() => {
            //     //移动平均线没值 才渲染正常价格数据 
            //     if (this.start && !this.fatherSmaData[0]) {
            //           //移动平均线没值 才渲染正常价格数据 
            //     if (this.start && !this.fatherSmaData[0]  && this.params.radius =="BTC") {
            //         this.btcFlag = true
            //         this.handelSonBtcPrice("BTC", true);  
            //         this.$addStorageEvent(1, "btcFlag", JSON.stringify(true));               
            //     }else  if (this.start  && this.params.radius =="ETH") {
            //         this.ethFlag = true
            //         this.handelSonEthPrice("ETH", true);
            //         this.$addStorageEvent(1, "ethFlag", JSON.stringify(true));
            //     }
            //     }
            //     //点击时间 移动平均线有值 就渲染查询移动平均线
            //     if (this.fatherSmaData[0] && this.start) {
            //         this.handelSonSma(this.fatherSmaData, this.start, this.end)
            //     }

            //       //渲染ETH
            //       if (this.ethFlag) {
            //         this.$addStorageEvent(1, "ethFlag", JSON.stringify(this.ethFlag));
            //         this.handelSonEthPrice("ETH", this.ethFlag)
            //     }
            //     //渲染BTC价格
            //     if (this.btcFlag) {
            //         this.$addStorageEvent(1, "btcFlag", JSON.stringify(this.btcFlag));
            //         this.handelSonBtcPrice("BTC", this.btcFlag)
            //     }



            // })

            // this.handelSonEthPrice("ETH", true);
            let rewardValueList = []
            let priceValueList = []
            this.rewardData.forEach(item => {

                rewardValueList.push(Number(item.value.toFixed(2)))
                priceValueList.push(Number(item.price.toFixed(2)))

            })
            this.option.series[0].data = handelProfitrate(this.rewardData, rewardValueList)
            this.option.series[1].data = handelProfitrate(this.rewardData, priceValueList)
            this.inCharts()
            this.rewardLoading = false
            //判定页面条数是否一致
            if (this.lengthTimer) {
                clearTimeout(this.lengthTimer)
            }
            this.lengthTimer = setTimeout(() => {

                this.$addStorageEvent(1, "lengthFlag", dataLength(this.option, this.option.series[0].data.length), );

            }, 10000)
        },
        //接收Home传的时间handelParmesTime
        handelSonTime(start, end) {
            this.params.start = start;
            this.params.end = end;
            this.fetchReward(this.params.req, this.params.radius, this.params.start, this.params.end, this.sma)

        },
        //点击对数/线性按钮切换
        handelLineSwitch() {
            this.option = handelLineType(this.option)
            this.switch3 = handelSwitchs(this.option, this.switch3)
            this.myChart.setOption(this.option);

        },
        //父级点击BTC价格按钮
        handelSonBtcPrice(radius, flag) {
            //父级BTC默认是true 在ETH页面btcFlag 取反才能正常点击父级就渲染

            // if (this.params.radius == "ETH") {
            //     this.btcFlag = !flag;
            // } else {
            //     this.btcFlag = flag;
            // }
            this.btcFlag = flag;

            fetchBtcPrice("BTC", this.option.series[1], this.start, this.end, this.inCharts, this, this.btcFlag)

        },
        //父级点击ETH价格按钮
        handelSonEthPrice(radius, flag) {

            this.ethFlag = flag;
            fetchEthPrice("ETH", this.option.series[1], this.start, this.end, this.inCharts, this, this.ethFlag)
        },
        //父级选择Sma
        handelSonSma(smaDataList) {



            this.sma = smaDataList
            this.fetchReward(this.params.req, this.params.radius, this.params.start, this.params.end, this.sma)


            this.$addStorageEvent(1, "sma", this.sma);



            // this.fatherSmaData = smaDataList
            // handelSmaData(smaDataList, this.option.series[1], this.inCharts, this.start, this.end,)

        },

    },
    beforeDestroy() {
        if (this.lengthTimer) {
            clearTimeout(this.lengthTimer)
        }
    }
}